import React from 'react';

const AgentPromptDocumentation = () => {
    return (
        <div>
            <h2>Agent & Prompt Documentation</h2>

            <h3>1. Prompt Template</h3>
            <p>
                This file contains 5 sheets that provide detailed information about agent prompts. You can view the prompt template by following the link below:
            </p>
            <a href="https://docs.google.com/spreadsheets/d/1N_q26YI70J3KJCYE1w7b5Bq5IJz3PXlv/edit?usp=sharing&ouid=109568034842682273600&rtpof=true&sd=true" target="_blank" rel="noopener noreferrer">
                View Prompt Template
            </a>
            <p><strong>Summary of Sheets:</strong></p>
            <ul>
                <li><strong>Agents Summary:</strong> This sheet contains the definition, concept understanding, and examples. Changes in this sheet will automatically reflect in the agent prompting.</li>
                <li><strong>Prompts:</strong> This sheet contains the prompt structure for the agent. Please do not make changes to this sheet.</li>
                <li><strong>Agent Prompt Mapping:</strong> This sheet contains the final prompt fed into the application. Changes should be made in the 'Agent Summary' sheet, not here.</li>
                <li><strong>Indicators Assessment:</strong> This sheet contains mapping of the indicators for each example and where they can be found (e.g., visual information, user journey context).</li>
                <li><strong>Agent Activation Stages:</strong> This sheet is used for ideation, focusing on filtering agent actions based on user journey stages.</li>
            </ul>

            <h3>2. Project Nudges Database</h3>
            <p>
                The Project Nudges Database contains research on various instances of deceptive designs. View the full database by following the link below:
            </p>
            <a href="https://docs.google.com/spreadsheets/d/1MNnew0POFTLJ_pQJrvhRUkrKXO3R9woB/edit?usp=sharing&ouid=109568034842682273600&rtpof=true&sd=true" target="_blank" rel="noopener noreferrer">
                View Project Nudges Database
            </a>
            <p><strong>Summary of Sheets:</strong></p>
            <ul>
                <li><strong>Source:</strong> Contains research information.</li>
                <li><strong>Nudges Database:</strong> Contains instances gathered from secondary research. Feel free to explore the samples.</li>
            </ul>

            <h3>3. Agent Validation</h3>
            <p>
                The Agent Validation sheet lists the tested instances for specific agents. You can view the validation sheet by following the link below:
            </p>
            <a href="https://docs.google.com/spreadsheets/d/1OLxSSsWSuUtT6QA80iNhgLCvG6moApUA/edit?usp=sharing&ouid=109568034842682273600&rtpof=true&sd=true" target="_blank" rel="noopener noreferrer">
                View Agent Validation
            </a>
            <p>This sheet includes:</p>
            <ul>
                <li><strong>Agent Name:</strong> Column D</li>
                <li><strong>Image URL:</strong> Column G</li>
                <li><strong>Agent Outcomes:</strong> Column O</li>
            </ul>
        </div>
    );
};

export default AgentPromptDocumentation;
